export default "__VITE_ASSET__BTP_9Odc__"